var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legend", attrs: { "data-field": _vm.externalKey } },
    [
      _c("p", {
        staticClass: "legend__value",
        class: _vm.classNames,
        domProps: { innerHTML: _vm._s(_vm.value) }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "legend__description" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }